// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__8mYHi","input":"styles_input__KpoRN","wrapper":"styles_wrapper__d1b3o"};